import React from "react";
import { GST_EXCLUSIVE, GST_FREE } from "../../modules/PriceBlock/GstTypes";
import isValidPrice from "../../utils/isValidPrice";
import Spinner from "../Spinner/Spinner";

const getGstTypeDisplayValue = (gstType) => {
  switch (gstType) {
    case GST_FREE:
      return "gst free";

    case GST_EXCLUSIVE:
      return "exc. gst";

    default:
      return "inc. gst";
  }
};

const getPriceDisplayValue = (price) => {
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return isValidPrice(price)
    ? Number(price).toLocaleString("en-AU", options)
    : price;
};

const PriceDisplay = ({
                        price,
                        priceError,
                        priceLoading,
                        gstType,
                        stockAvailability,
                        isMax,
                        isStockLoading,
                        isPriceListLoading,
                        purchaseControl,
                      }) => {
  if (priceLoading || isPriceListLoading || (isMax && isStockLoading)) {
    return <Spinner size="18px" />;
  }

  if (purchaseControl === "NOT_AVAILABLE") {
    return (
      <div className="pdp-prices-block__price-unavailable">
      </div>
    );
  }

  if (
    priceError ||
    price == null ||
    stockAvailability === "NO_LONGER_AVAILABLE"
  ) {
    return (
      <div className="pdp-prices-block__price-unavailable">
        Price unavailable
        <div className="pdp-prices-block__contact-branch">
          Contact your <a href="/storefinder">local branch</a> for more
          information.
        </div>
      </div>
    );
  }

  return (
    <div className="pdp-prices-block__price">
      <span className="pdp-prices-block__price-val">
        {getPriceDisplayValue(price)}
      </span>
      <span className="pdp-prices-block__gst-mark">
        {getGstTypeDisplayValue(gstType)}
      </span>
    </div>
  );
};

export default PriceDisplay;